import { syncSeatingOrderDefaultReducerState } from './defaultState'
import { ReduxAction } from '../../reducerType'
import { SyncSeatingOrderReducer } from './types'
import produce, { Draft } from 'immer'
import { SeatingOrderType } from '../../../actions/seatingOrder/seatingOrderTypes'

export default produce((draftState: Draft<SyncSeatingOrderReducer>, { type, payload }: ReduxAction) => {

  switch (type) {

    case SeatingOrderType.SET_SEATING_ORDER_STATE:
      draftState.seatingOrder = payload
      break
    case SeatingOrderType.SEAT_UPDATED: case SeatingOrderType.SEAT_ADDED:
      draftState.seatingOrder[payload.key] = payload.data
      break
    case SeatingOrderType.SEAT_REMOVED:
      delete draftState.seatingOrder[payload]
      break
    default:
      break

  }

}, syncSeatingOrderDefaultReducerState)
